export default {

  getUploadedMedicalOrders(state) {
    return state.data.uploadedMedicalOrders;
  },

  hasMedicalOrdersSentToAnalyze(state) {
    return state.data.hasSentToAnalyze;
  },

};
